export type ConfirmationTranslate = (key: string, options?: { defaultValue: string }) => string;

const COPY_ROOT = 'aiInsights.mutationConfirmation';

export const translateFieldLabel = (t: ConfirmationTranslate, tool: string, name: string, fallback: string): string =>
  t(`${COPY_ROOT}.fieldLabels.${tool}.${name}`, { defaultValue: fallback });

export const translateWarning = (t: ConfirmationTranslate, tool: string, fallback: string): string =>
  t(`${COPY_ROOT}.warnings.${tool}`, { defaultValue: fallback });

export const translateSummary = (t: ConfirmationTranslate, tool: string, fallback: string): string =>
  t(`${COPY_ROOT}.toolTitles.${tool}`, { defaultValue: fallback });
